import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from './firebaseConfig';
import './Sidebar.css';

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <aside className="ozia-sidebar">
      <div className="sidebar-header">
        <img src="/logo.png" alt="OZIA" className="sidebar-logo" />
        <h2>OZIA AI</h2>
      </div>

      <nav className="sidebar-nav">
        <NavLink to="/chat" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <i className="fas fa-comment-dots"></i>
          <span>Chat</span>
        </NavLink>

        <NavLink to="/profile" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <i className="fas fa-user-circle"></i>
          <span>Profile</span>
        </NavLink>

        <NavLink to="/settings" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <i className="fas fa-cog"></i>
          <span>Settings</span>
        </NavLink>

        <NavLink to="/payment" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <i className="fas fa-bolt"></i>
          <span>Upgrade</span>
        </NavLink>
        
        <NavLink to="/help" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <i className="fas fa-question-circle"></i>
          <span>Help</span>
        </NavLink>
      </nav>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn-sidebar">
          <i className="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;